// extracted by mini-css-extract-plugin
module.exports = {"success":"index-module_success_suCDH","tip":"index-module_tip_1k42J","tip-title":"index-module_tip-title_3Widm","tip-desc":"index-module_tip-desc_2KgPm"};